import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseDiscountCreatedTemplates = [
  {
    id: '-212001',
    language: Language.EN,
    subject: 'A discount has been added to your lease',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_DISCOUNT_CREATED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Dear tenant,</p>
          <p>We inform you that you have been granted a discount of {{lvo.amount}} €.</p>
          <p>All details here: {{pdfLink}}.</p>
          <p>Kind regards.</p>
      `,
  },
  {
    id: '-212002',
    language: Language.FR,
    subject: 'Une remise a été ajoutée à votre bail',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_DISCOUNT_CREATED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Cher/Chère locataire,</p>
          <p>Nous vous informons qu'une remise de {{lvo.amount}} € vous est octroyée.</p>
          <p>Plus de détails ici: {{pdfLink}}.</p>
          <p>Bien à vous.</p>
      `,
  },
  {
    id: '-212003',
    language: Language.NL,
    subject: 'Een korting werd aan uw huurcontract toegevoegd',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_DISCOUNT_CREATED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Beste huurder,</p>
          <p>Wij informeren u dat u een korting van {{lvo.amount}} € is toegekend.</p>
          <p>Alle details hier: {{pdfLink}}.</p>
          <p>Groeten.</p>
      `,
  },
  {
    id: '-212004',
    language: Language.DE,
    subject: 'Ein Rabatt wurde zu Ihrem Mietvertrag hinzugefügt',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_DISCOUNT_CREATED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Sehr geehrte/r Mieter/in,</p>
          <p>Wir informieren Sie, dass Ihnen ein Rabatt von {{lvo.amount}} € gewährt wurde.</p>
          <p>Alle Details hier: {{pdfLink}}.</p>
          <p>Mit freundlichen Grüßen.</p>
      `,
  },
];
